// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Blank-dash-3904{width:40px;height:40px;border-radius:50%;border:1px dashed var(--ui-text-color)}`, "",{"version":3,"sources":["webpack://./src/page/ProfileScreen/Selfies/Blank.module.scss"],"names":[],"mappings":"AAAA,iBACE,UAAA,CACA,WAAA,CACA,iBAAA,CACA,sCAAA","sourcesContent":[".dash {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px dashed var(--ui-text-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dash": `Blank-dash-3904`
};
module.exports = ___CSS_LOADER_EXPORT___;
